import { useWorkspaceText } from '../interface-copy';
import { useState } from 'react';
import { companyRequest } from '@/company/api';
import { useWorkspace } from '../context';

// An agent's acting user follows the server-owned stream. Stopping that
// exact stream uses the ordinary owner-only resume cancellation route;
// aborting a follower transport must continue to stop only that subscription.
function StopRun({ streamId }: { streamId: string }) {
  const { text: uiText, rich: uiRich } = useWorkspaceText();
  const [stopping, setStopping] = useState(false);
  const [failed, setFailed] = useState(false);
  async function stop() {
    if (stopping) return;
    setStopping(true);
    setFailed(false);
    try {
      await companyRequest(`/api/chat/resume/${encodeURIComponent(streamId)}`, 'DELETE');
    } catch {
      setStopping(false);
      setFailed(true);
    }
  }
  return (
    <div>
      <button className="ws-button" disabled={stopping} onClick={() => void stop()}>
        {stopping ? uiText('Stopping…') : uiText('Stop run')}
      </button>
      {failed && <p role="alert">{uiText('Could not stop this run. Please try again.')}</p>}
    </div>
  );
}

/** The acting user's run chat stays read-only while the agent answers. */
export function RunFollowBar() {
  const { text: uiText, rich: uiRich } = useWorkspaceText();
  const ws = useWorkspace();
  const streamId = ws.threadLive?.streamId;
  const ownsRun = ws.threadMeta?.access === 'owner' && Boolean(ws.threadMeta.agentRunId);
  return (
    <div className="ws-readonly-bar" role="region" aria-label={uiText('Run in progress')}>
      <div className="ws-readonly-lead">
        <span className="ws-live-dot" aria-hidden="true" />
        <p>{uiText('This run is still answering. You can ask follow-ups when it finishes.')}</p>
        {ownsRun && streamId && <StopRun key={streamId} streamId={streamId} />}
      </div>
    </div>
  );
}
